<template>
    <MstBukaSearch />
</template>

<script lang="ts">
import {defineComponent } from 'vue'
import MstBukaSearch from '@/components/master/buka/BukaSearch.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      MstBukaSearch
    }
})
</script>
